<template lang="pug">
  .text-editor(
    :class="{'text-editor_focused': isFocused}"
  )
    EditorMenuBar(
      :editor="editor"
      v-slot="{ commands, isActive }"
    )
      .text-editor-menu
        .text-editor-menu__left
          button.link.link_inherit(
            tabindex="-1"
            type="button"
            v-for="control in controls"
            :class="{ 'active': controlsOptions[control].toggle && isActive[control]() }"
            @click="commands[controlsOptions[control].command]()"
          )
            icon(:icon-name="controlsOptions[control].icon")
        .text-editor-menu__right(v-if="hasHistory")
          button.link.link_inherit(
            tabindex="-1"
            type="button"
            @click="commands.undo"
          )
            icon(icon-name="undo")
          button.link.link_inherit(
            tabindex="-1"
            type="button"
            @click="commands.redo"
          )
            icon(icon-name="redo")
    EditorContent.text-editor-content.text-content(
      :editor="editor"
    )
</template>

<script>
import { Editor, EditorMenuBar, EditorContent } from 'tiptap'
import { Bold, Italic, Strike, Underline, BulletList, ListItem, OrderedList, HardBreak, History, Placeholder } from 'tiptap-extensions'

export default {
  name: 'TextEditor',
  components: {
    EditorMenuBar,
    EditorContent
  },
  props: {
    content: String,
    hasHistory: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Array,
      default () {
        return ['bold', 'italic', 'strike', 'underline', 'bullet_list', 'ordered_list']
      }
    }
  },
  data () {
    return {
      controlsOptions: {
        bold: {
          icon: 'bold',
          toggle: true,
          command: 'bold'
        },
        italic: {
          icon: 'italic',
          toggle: true,
          command: 'italic'
        },
        strike: {
          icon: 'strike',
          toggle: true,
          command: 'strike'
        },
        underline: {
          icon: 'underline',
          toggle: true,
          command: 'underline'
        },
        bullet_list: {
          icon: 'unordered-list',
          toggle: true,
          command: 'bullet_list'
        },
        ordered_list: {
          icon: 'ordered-list',
          toggle: true,
          command: 'ordered_list'
        }
      },
      editor: new Editor({
        extensions: [
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new HardBreak(),
          new History(),
          new Placeholder({
            emptyEditorClass: 'is-editor-empty',
            emptyNodeClass: 'is-empty',
            emptyNodeText: 'Начните писать здесь...',
            showOnlyWhenEditable: true,
            showOnlyCurrent: true
          })
        ],
        content: this.content,
        onUpdate: ({ getHTML }) => {
          this.$emit('update', getHTML())
        }
      })
    }
  },
  computed: {
    isFocused () {
      return this.editor.focused
    }
  },
  beforeDestroy () {
    this.editor.destroy()
  }
}
</script>

<style lang="scss">
  .text-editor {
    border: 1px solid map_get($color-neutral-black, 45);
    border-radius: $border-radius;
    padding: 7px 8px;
    transition: $transition-default;
    transition-property: border, box-shadow;

    &_focused {
      border-color: map_get($color-neutral-black, 65);
      box-shadow: 0 0 0 1px map_get($color-neutral-black, 65);
    }

    .form_show-err .has-error & {
      border-color: $color-danger;

      &_focused {
        box-shadow: 0 0 0 1px $color-danger;
      }
    }

    // Placeholder
    .is-editor-empty:first-child::before {
      content: attr(data-empty-text);
      float: left;
      color: map_get($color-neutral-black, 25);
      pointer-events: none;
      height: 0;
    }
  }

  .text-editor-content {
    padding: 12px 16px;

    @media (max-width: breakpoint(sm, max)) {
      min-height: 48 + 24px;
    }
  }

  .text-editor-menu {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    line-height: 1;
    padding: 4px 8px 2px;

    &__left {
      margin-right: auto;
      padding-right: 4px;
    }

    button {
      vertical-align: middle;
      border-radius: 2px;
      width: 32px;
      height: 24px;
      margin-right: 4px;
      margin-bottom: 2px;

      &.active {
        background-color: map_get($color-neutral-black, 9);
      }

      .svg-icon {
        width: 18px;
        height: 18px;
        vertical-align: middle;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>
